import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { LoadingStatus } from '../../../../../../core/domain/events/state_provider';
import { DietitianStateProvider } from '../../../../../../data/dietitian/domain/dietitian_state_provider';
import { EncouragementCommands } from '../../../../../../data/dietitian/domain/encouragement/encouragement_commands';
import { ScheduledTaskEvent } from '../../../../../../data/dietitian/domain/events/scheduled_task/scheduled_task_events';
import {
  ScheduledTask,
  ScheduledTaskType,
} from '../../../../../../data/dietitian/domain/scheduled_task/scheduled_task';
import { ScheduledTaskCommands } from '../../../../../../data/dietitian/domain/scheduled_task/scheduled_task_commands';
import { QuestionsViewModel } from '../../questions.facade';

@Injectable()
export class ScheduledTaskFacade {
  constructor(
    private dietitianStateProvider: DietitianStateProvider,
    private dietitianEncouragementCommands: EncouragementCommands,
    private scheduledTaskCommands: ScheduledTaskCommands,
  ) {
    // nada
  }

  get scheduledTaskStatus$(): Observable<QuestionsViewModel> {
    return this.dietitianStateProvider.state$.pipe(
      map((e) => {
        return <QuestionsViewModel>{
          isLoading: e.loading == LoadingStatus.LOADING,
          error: e.loading == LoadingStatus.ERROR ? e.message : undefined,
          dietitian: e.entity,
        };
      }),
    );
  }

  get scheduledTaskEventsObserver(): Observable<ScheduledTaskEvent> {
    return this.scheduledTaskCommands.scheduledTaskEventsObserver();
  }

  async getDietitianEncouragementCount(dietitianId: string): Promise<number> {
    return this.dietitianEncouragementCommands.getDietitianEncouragementCount(
      dietitianId,
    );
  }

  async getDietitianEncouragementCountByGroup(
    dietitianId: string,
    groupId: string,
  ): Promise<number> {
    return this.dietitianEncouragementCommands.getDietitianEncouragementCountByGroup(
      dietitianId,
      groupId,
    );
  }

  async getDietitianScheduledTaskCountByType(
    dietitianId: string,
    type: ScheduledTaskType,
  ): Promise<number> {
    return this.scheduledTaskCommands.countScheduledTaskByType(
      dietitianId,
      type,
    );
  }

  async getDietitianScheduledTaskCountByGroupAndType(
    dietitianId: string,
    groupId: string,
    type: ScheduledTaskType,
  ): Promise<number> {
    return this.scheduledTaskCommands.countScheduledTaskByGroupAndType(
      dietitianId,
      groupId,
      type,
    );
  }

  async getScheduledTasks(
    dietitianId: string,
    type: ScheduledTaskType,
    groupId?: string | undefined,
  ): Promise<ScheduledTask[]> {
    return this.scheduledTaskCommands.getScheduledTasks(
      dietitianId,
      type,
      groupId,
    );
  }

  async deleteScheduledTask(dietitianId: string, scheduledTaskId: string) {
    return this.scheduledTaskCommands.deleteScheduledTask(
      dietitianId,
      scheduledTaskId,
    );
  }

  async deleteScheduledTasks(
    dietitianId: string,
    type: ScheduledTaskType,
    groupId: string | undefined,
  ) {
    return this.scheduledTaskCommands.deleteScheduledTasks(
      dietitianId,
      type,
      groupId,
    );
  }

  async getPatientRecipient(patientId: string): Promise<string | undefined> {
    return this.scheduledTaskCommands.getPatientRecipient(patientId);
  }
}
